class SignInPresenter {
  constructor(view, signInUseCase) {
    this.view = view;
    this.signInUseCase = signInUseCase;
    this.change = {};
  }

  onChange(value, field) {
    this.change[field] = value;
  }

  async submit() {
    const isApplicantWalkIn = this.view.isApplicantWalkIn();
    try {
      const user = { ...this.change };
      this.view.showProgress();
      const signedInUser = await this.signInUseCase.execute(user);

      const userRole = JSON.stringify(signedInUser);
      const selectedJobs = localStorage.getItem("selectedJobs");

      signedInUser.roles?.forEach((role) => {
        if (role?.id === "Admin") {
          this.view.navigateTo("/admin/employees");
        } else if (role?.id === "Applicants") {
          if (selectedJobs && !isApplicantWalkIn) {
            this.view.navigateTo("/job-list/application-form");
          } else if (isApplicantWalkIn) {
            this.view.navigateTo(
              `/application-form/walkin_applicants/${isApplicantWalkIn}`
            );
          } else {
            this.view.navigateTo("/");
          }
          localStorage.setItem("user", userRole);
        }
      });

      this.view.reload();
    } catch (error) {
      this.view.hideProgress();
      this.view.showError(error);
    }
  }
}

export default SignInPresenter;
